import { render, staticRenderFns } from "./EntryMessageSentDate.vue?vue&type=template&id=5cb38e5c"
import script from "./EntryMessageSentDate.vue?vue&type=script&lang=js"
export * from "./EntryMessageSentDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports